import {Component, Input} from '@angular/core';
import {MyModalProvider} from "../../providers/my-modal/my-modal";
import {Global, global} from "../../environments/global";

/**
 * Generated class for the ModalTypeHelpComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'modal-type-help',
  templateUrl: 'modal-type-help.html'
})
export class ModalTypeHelpComponent {

  global: Global = global;

  @Input() data: any;

  constructor(private myModal: MyModalProvider) {
    console.log('Hello ModalTypeHelpComponent Component');
  }

  cancel(){
    this.myModal.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/components/modal-type-help/modal-type-help.ts